import React from "react";

function cn(...parts) {
    return parts.filter(Boolean).join(" ");
}

/**
 * Shared table chrome for Sale detail tabs: matches Parts section
 * (Sale-table-list + Sale-parts-table).
 */
export default function SaleRecordTable({
    columns,
    rows,
    getRowKey,
    tableClassName = "",
    wrapClassName = "Sale-record-table-wrap",
    onRowClick,
    rowClassName,
}) {
    return (
        <div className={cn(wrapClassName)}>
            <table className={cn("Sale-table-list", "Sale-parts-table", tableClassName)}>
                <thead>
                    <tr>
                        {columns.map((col) => (
                            <th
                                key={col.id}
                                scope="col"
                                style={col.width ? { width: col.width } : undefined}
                                className={cn(
                                    col.align === "right" && "Sale-record-table-th-right",
                                    col.align === "center" && "Sale-record-table-th-center",
                                    col.headerClassName,
                                )}
                            >
                                {col.header}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row, rowIndex) => (
                        <tr
                            key={getRowKey(row, rowIndex)}
                            className={cn(
                                onRowClick && "Sale-parts-clickable-row",
                                typeof rowClassName === "function"
                                    ? rowClassName(row, rowIndex)
                                    : rowClassName,
                            )}
                            onClick={onRowClick ? () => onRowClick(row, rowIndex) : undefined}
                        >
                            {columns.map((col) => {
                                const cellCls =
                                    typeof col.cellClassName === "function"
                                        ? col.cellClassName(row, rowIndex)
                                        : col.cellClassName;
                                return (
                                    <td
                                        key={col.id}
                                        style={col.width ? { width: col.width } : undefined}
                                        className={cn(
                                            col.align === "right" && "Sale-record-table-td-right",
                                            col.align === "center" && "Sale-record-table-td-center",
                                            cellCls,
                                        )}
                                    >
                                        {col.cell(row, rowIndex)}
                                    </td>
                                );
                            })}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
